import { FC } from "react"
import styled from "styled-components"
import Image from "next/image"

import { RichText } from "@components/common"
import { ContentfulProduct } from "@lib/types"

type Props = ContentfulProduct["sizeChart"]

export const SizeChart: FC<Props> = ({ title, table, image, richText }) => {
  return (
    <StyledSizeChart>
      <Title>{title}</Title>
      <SizeChartTable>
        <tr>
          <th></th>
          <th>{table.tableData[0][1]}</th>
        </tr>
        {table.tableData.slice(1).map(tr => (
          <tr>
            {tr.map(td => (
              <td>{td}</td>
            ))}
          </tr>
        ))}
      </SizeChartTable>
      {image && (
        <SizeChartIllustration>
          <ImageWrapper>
            <Image
              src={image.url}
              alt={image.description}
              width={image.width}
              height={image.height}
              layout="fixed"
            />
          </ImageWrapper>
          <RichText richText={richText} />
        </SizeChartIllustration>
      )}
    </StyledSizeChart>
  )
}

const StyledSizeChart = styled.div`
  font-family: ${({ theme }) => theme.font.heading};
`

const Title = styled.h1`
  margin: 0;
  font-size: 2rem;
  font-style: normal;
  font-weight: 400;
  line-height: 4rem;
  text-align: center;
`

const SizeChartTable = styled.table`
  font-size: 1.2rem;
  line-height: 2.4rem;
  letter-spacing: 0.04em;
  width: 100%;

  th {
    margin: 0 0 0.7rem;
    text-transform: uppercase;
    font-size: 1.2rem;
    font-style: normal;
    font-weight: 400;
    line-height: 2.4rem;
    letter-spacing: 0.12em;
    text-align: left;
  }

  td {
    border-top: 1px solid ${({ theme }) => theme.color.greyLight};

    &:first-child {
      text-transform: uppercase;
      font-weight: 500;
      padding: 0.7rem 0;
      padding-right: 5.8rem;
      letter-spacing: 0.12em;
    }
  }
`

const SizeChartIllustration = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0.5rem;

  b {
    font-weight: 500;
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.md}px) {
    flex-direction: row;
  }
`

const ImageWrapper = styled.div`
  margin: 0 0 1.4rem;
  flex-shrink: 0;

  @media (min-width: ${({ theme }) => theme.breakpoint.md}px) {
    margin: 0 1.4rem 0 0;
  }
`
